// §13.7 數字一律以 kg 儲存，小數位由量測點設定控制顯示
export function kg(v, decimals = 2) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    return v.toLocaleString('zh-Hant-TW', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}
export function kgUnit(v, decimals = 2) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    return `${kg(v, decimals)} kg`;
}
export function pct(v, decimals = 2) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    return `${(v * 100).toFixed(decimals)}%`;
}
export function count(v) {
    if (v === null || v === undefined)
        return '—';
    return v.toLocaleString('zh-Hant-TW');
}
export function ts(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}
export function tsShort(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
export function round(v, decimals = 3) {
    const f = Math.pow(10, decimals);
    return Math.round(v * f) / f;
}
/**
 * 型號在下拉選單與清單上的顯示文字。
 *
 * 只顯示 label（「72-cell 標準型」）辨識度不夠——現場看到的標籤上印的是**型號代碼**，
 * 而畫面上卻找不到它。所以代碼放最前面，後面才是人看的名稱與品牌。
 *
 * 排版刻意固定成「代碼 · 品牌 · 名稱」：代碼在最左邊，一整排下拉才對得齊、掃得快。
 */
export function modelOptionLabel(spec) {
    const parts = [spec.modelCode];
    if (spec.manufacturer)
        parts.push(spec.manufacturer);
    const name = spec.ratedW ? `${spec.label}（${spec.ratedW}W）` : spec.label;
    if (name && name !== spec.modelCode)
        parts.push(name);
    const base = parts.join(' · ');
    return spec.status === 'provisional' ? `${base}〔暫定〕` : base;
}
//# sourceMappingURL=format.js.map